// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".discountYouSave .additionalInfo p {\n  margin: 0;\n}", "",{"version":3,"sources":["/dvl/rakarapu/compiere-all/pharmanord2011/template/webapps/buybuttoncompact/src/components/buybuttonv2.vue"],"names":[],"mappings":"AAGI;EACE,SAAA;AAFN","file":"buybuttonv2.vue","sourcesContent":["\n.discountYouSave {\n  .additionalInfo {\n    p {\n      margin: 0;\n    }\n  }\n}"]}]);
// Exports
module.exports = exports;
